import Loadable from "app/components/Loadable";
import { lazy } from "react";

const Shop = Loadable(lazy(() => import("./Shop")));
const Cart = Loadable(lazy(() => import("./Cart")));
const Checkout = Loadable(lazy(() => import("./Checkout")));

const ecommerceRoutes = [
  { path: "/marketplace", element: <Shop /> },
  { path: "/marketplace/cart", element: <Cart /> },
  { path: "/marketplace/checkout", element: <Checkout /> },
];

export default ecommerceRoutes;
